import React, { Component } from 'react';
import StepZilla from 'react-stepzilla';
import {connect} from 'react-redux';
import { push } from 'connected-react-router';
import Step1 from './Step1/Step1';
import Step2 from './Step2/Step2';
import Step3 from './Step3/Step3';
import {
	Card,
	CardBody,
	CardTitle,
	Alert,
} from 'reactstrap';
import { saveNewCompany } from '../../actions/companyActions';
import {fetchCities, fetchCountries} from '../../actions/geoActions';
import {I18n} from '../../I18n/components/createCompany';
import 'react-table/react-table.css';
import './createCompany.css';

class CreateCompany extends Component {
	constructor(props) {
		super(props);
		this.state = {
			saveStatus: false,
			selectedCountry: null
		};

		this.sampleStore = {
			name: '',
			types: [],
			countryCode: '',
			cityGeonameId: '',
			manager: '',
			phone: '',
			email: '',
			skype: '',
			savedToCloud: false,
		};
	}

	componentDidMount() {
		(async () => {
			try {
				await this.getGeo();
			} catch(err) {
				console.error(err);
			}
		})();
	}

	componentDidUpdate(prevProps) {
		if (this.props.lang !== prevProps.lang) {
			(async() => await this.getGeo())();
		}
	}

	getGeo = async () => {
		try{
			const countries = await this.props.fetchCountries({
				lang: this.props.lang
			});
			const cities = await this.props.fetchCities({
				lang: this.props.lang,
				countryCode: this.state.selectedCountry ?
					this.state.selectedCountry : this.props.companies[0].countryCode
			});
		} catch(err) {
			console.error(err);
		}
	};

	updateCountry = async event => { // get country and sities
		const selectedCountry = event.target.value;
		try{
			const cities = await this.props.fetchCities({
				lang: this.props.lang,
				countryCode: selectedCountry
			});
			this.setState({
				selectedCountry
			})
		} catch(err){
			console.error(err);
		}
	};

	getStore() {
		return this.sampleStore;
	}

	updateStore(update) {
		this.sampleStore = {
			...this.sampleStore,
			...update,
		};
		this.setState({
			saveStatus: update.savedToCloud
		});
	}

	onSaveNewCompany = () => {
		console.log('save', this.sampleStore);
		if (!this.sampleStore.savedToCloud) {
			this.props.saveNewCompany({
				name: this.sampleStore.name,
				types: this.sampleStore.types,
				countryCode: this.sampleStore.countryCode,
				cityGeonameId: this.sampleStore.cityGeonameId,
				manager: this.sampleStore.manager,
				phoneNumber: this.sampleStore.phone,
				email: this.sampleStore.email,
				skype: this.sampleStore.skype,
			}).then(res => {
				if (!this.props.error) {
					this.updateStore({
						savedToCloud: true
					});
				}
			});
		}
	};

	onStart = () => {
		this.props.changeLocation('/dashboard/companies');
	};

	render() {
		const {lang} = this.props;
		const steps =
			[
				{
					name: `${I18n[lang].step_one}`,
					component: <Step1
						lang={lang}
						getStore={() => (this.getStore())}
						updateStore={(u) => { this.updateStore(u) }}
						countries={this.props.countriesList}
						cities={this.props.citiesList}
						updateCountry={this.updateCountry}
					/>
				},
				{
					name: `${I18n[lang].step_two}`,
					component: <Step2
						lang={lang}
						getStore={() => (this.getStore())}
						updateStore={(u) => { this.updateStore(u) }}
						countries={this.props.countriesList}
						cities={this.props.citiesList}
					/>
				},
				{
					name: `${I18n[lang].step_three}`,
					component: <Step3
						lang={lang}
						getStore={() => (this.getStore())}
						updateStore={(u) => { this.updateStore(u) }}
						onSave={this.onSaveNewCompany}
						onStart={this.onStart}
						loading={this.props.loading}
						saveStatus={this.state.saveStatus}
						countries={this.props.countriesList}
						cities={this.props.citiesList}
					/>
				}
			];
		return (
			<Card className='create-company'>
				<CardBody className="border-bottom">
					<CardTitle className="mb-0 create-company__title"><i className="mdi mdi-border-right mr-2"></i>{I18n[lang].create}</CardTitle>
				</CardBody>
				<CardBody>
					<div className='create-company__body'>
						{/*----------------------- alerts -----------------------------------*/}
						<Alert
							color={`${this.props.alert.alert.status}`}
							isOpen={this.props.alert.isOpen || false}
						>
							{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
						</Alert>
						<div className='step-progress'>
							<StepZilla
								steps={steps}
								nextButtonText={I18n[lang].nextBtn}
								backButtonText={I18n[lang].prevBtn}
								prevBtnOnLastStep={false}
							/>
						</div>
					</div>
				</CardBody>
			</Card>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		saveNewCompany: newCompany => dispatch(saveNewCompany(newCompany)),
		// closeAlert: () => dispatch(closeAlert()),
		changeLocation: url => dispatch(push(url)),
		fetchCountries: query => dispatch(fetchCountries(query)),
		fetchCities: query => dispatch(fetchCities(query)),
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	addedCompany: state.addCompanyReducer.company,
	loading: state.addCompanyReducer.loading,
	error: state.addCompanyReducer.error,
	// pagination: state.users.pagination,
	// loading: state.users.loading,
	companies: state.companiesReducer.companies,
	lang: state.languageReducer.lang,
	countriesList: state.countriesList.countries,
	citiesList: state.citiesList.cities
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateCompany)



// WEBPACK FOOTER //
// ./src/components/CreateCompany/CreateCompany.js